import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=4f1e7b78&"
import script from "./LoginRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports